import { render, staticRenderFns } from "./ShowApprovedRequestPage.vue?vue&type=template&id=11112d74"
import script from "./ShowApprovedRequestPage.vue?vue&type=script&lang=js"
export * from "./ShowApprovedRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports